import { useEffect } from 'react';

const fallbackSrc = '/Assets/no-image.jpg';

const GlobalImageFallback = ({ children }) => {
  useEffect(() => {
    const fallback = (img) => {
      if (!img) return;

      const width = img.clientWidth;
      const height = img.clientHeight;

      const applyFallback = () => {
        if (img.src === fallbackSrc) return; // Already fallback
        img.onerror = null; // prevent loop
        img.src = fallbackSrc;
        if (width > 0) img.style.width = `${width}px`;
        if (height > 0) img.style.height = `${height}px`;
        img.style.objectFit = 'contain';
      };

      const src = img.getAttribute('src') || '';
      if (!src || src.includes('null') || img.src === window.location.origin + '/') {
        applyFallback();
      }

      img.onerror = applyFallback;
    };

    const checkImages = () => {
      const images = document.querySelectorAll('img.product-img');
      images.forEach((img) => fallback(img));
    };

    checkImages();

    const observer = new MutationObserver(checkImages);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return children;
};

export default GlobalImageFallback;
